import { i18n } from 'shared/i18n';

export interface UnitLike {
  measure?: string | null;
  divideUnitNominator?: string | null;
  divideUnitDenominator?: string | null;
}

export const measureLabel = (measure: string): string => {
  if (measure === 'xbrli:shares') return i18n('tag:unit.shares');
  if (measure === 'xbrli:pure') return i18n('tag:unit.pure');
  return measure.replace(/^iso4217:/, '');
};

export const unitLabel = (unit: UnitLike): string => {
  if (unit.divideUnitNominator && unit.divideUnitDenominator) {
    return `${measureLabel(unit.divideUnitNominator)}/${measureLabel(unit.divideUnitDenominator)}`;
  }
  if (unit.measure) return measureLabel(unit.measure);
  return '-';
};

export interface UnitOption {
  value: string;
  label: string;
}

export function simpleCurrencyCode(spec: UnitLike): string | null {
  const m = spec.measure;
  if (m && m.startsWith('iso4217:') && !spec.divideUnitNominator && !spec.divideUnitDenominator) return m.replace(/^iso4217:/, '');
  return null;
}

export function nonConfigUnits<T extends { id: string } & UnitLike>(currencySelections: { currency: string }[], units: T[] | undefined): T[] {
  const configCodes = new Set(currencySelections.map((c) => c.currency));
  return (units ?? []).filter((u) => !(u.measure && u.measure.startsWith('iso4217:') && configCodes.has(u.measure.replace(/^iso4217:/, ''))));
}

export function buildUnitOptions(currencySelections: { currency: string }[], units: ({ id: string } & UnitLike)[] | undefined): UnitOption[] {
  const currencyOptions = currencySelections.map((c) => ({ value: c.currency, label: c.currency })).sort((a, b) => a.label.localeCompare(b.label));
  const unitOptions = nonConfigUnits(currencySelections, units).map((u) => ({ value: `unit:${u.id}`, label: unitLabel(u) }));
  return [...currencyOptions, ...unitOptions];
}
